module.exports = {
  sidebar:{
    language:'ENGLISH',
    index:'首页',
    dynamic:'展会动态',
    d_intro:'展会介绍',
    d_news:'展会新闻',
    d_media:'媒体报道',
    d_pic:'展会掠影',
    d_detail:'详情',
    empty:'',
    register:'观展登记',
    visitor:'我要参观',
    isit_course:'文件下载',
    service:'观展服务',
    about:'关于我们',
    contact:'联系我们',
    exhibitor:'参展商与产品',
    live:'展会直播',
    ennews:'News Center',
    overlive:'海外直通车',
    overlive_1:'2021海外直通车',
    overlive_2:'2020直播精彩回放'
  },
  footer:{
    about:'关于我们',
    contact:'联系我们',
    weixin:'官方微信',
    video:'官方视频'
  },
  index:{
    t1:'2023佛山潭洲陶瓷展',
    t2:'2023年',
    t3:'陶瓷产品与应用技术展',
    t4:'陶瓷装备与材料展',
    t5:'特色主题馆',
    t6:'展会最新动态',
    t7:'',
    blogroll:'友情链接',
    zcdw:'支持单位'
  },
  btn:{
    exhibitor:'观展登记入口',
    clickMe:'点我报名',
    visitor:'我要参观',
    more:'查看更多',
    haiwailive:'2020直播精彩回放'
  },
  lange: {
    language:'ENGLISH',
    cn:'Chinese',
    en:'ENEGLISH',
    jp:'日文',
    kr:'韩文'  
  }
}